import React from 'react';

import type { Control as RHFControl } from 'react-hook-form';

import { useArrayController } from './hooks/useArrayController';
import { OptionsFilter } from './OptionsFilter';
import type { OptionGroup, Option } from './types';

interface ControllableOptionsFilterProps {
  control: RHFControl;
  name: string;
  defaultValue?: Option['value'][];
  label?: string | undefined;
  options: OptionGroup<Option> | OptionGroup<Option>[] | Option[];
  isCreatable?: boolean | undefined;
  isSearchable?: boolean | undefined;
  visibleCount?: number | undefined;
  validateProp?: ((_: string) => string | boolean) | undefined;
}

export function ControllableOptionsFilter({
  control,
  name,
  options,
  label = undefined,
  isCreatable = false,
  isSearchable = true,
  visibleCount = undefined,
  validateProp = undefined,
  defaultValue = [],
}: ControllableOptionsFilterProps): React.JSX.Element {
  const arrayField = useArrayController({
    control,
    name,
    defaultValue,
  });

  return (
    <OptionsFilter
      defaultValue={defaultValue}
      isCreatable={isCreatable}
      isSearchable={isSearchable}
      label={label}
      name={name}
      onChange={arrayField.setValue}
      options={options}
      validateProp={validateProp}
      value={arrayField.values as string[]}
      visibleCount={visibleCount}
    />
  );
}
